import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { Observable } from "rxjs";
import { apiColletions } from "src/app/core/constant/api-collection";

@Injectable({
    providedIn: "root"
})
export class ProductService {
    constructor(private apiService: ApiService) { }

    getproductList(parameters: any): Observable<boolean> {
        return new Observable<boolean>((observer) => {
            this.apiService.get({ url: apiColletions.getProduct, parameters }).subscribe({
                next: (response) => {
                    if (response.data) {
                        observer.next(response.data);
                        observer.complete();
                    } else {
                        observer.next(false);
                        observer.complete();
                    }
                },
                error: () => {
                    observer.next(false);
                    observer.complete();
                }
            });
        });
    }

    getproductDetail(productId:string,parameters: any={}): Observable<boolean> {
        return new Observable<boolean>((observer) => {
            const api = `${apiColletions.getProductDetails}/${productId}`;
            this.apiService.get({ url:api , parameters }).subscribe({
                next: (response) => {
                    if (response.data) {
                        observer.next(response.data);
                        observer.complete();
                    } else {
                        observer.next(false);
                        observer.complete();
                    }
                },
                error: () => {
                    observer.next(false);
                    observer.complete();
                }
            });
        });
    }

    notifyProduct(parameters: any): Observable<boolean> {
        return new Observable<any>((observer) => {
            this.apiService.post({ url: apiColletions.notifyProduct, parameters }).subscribe({
                next: (response) => {
                    if (response.data) {
                        observer.next(response.data);
                        observer.complete();
                    } else {
                        observer.next(false);
                        observer.complete();
                    }
                },
                error: () => {
                    observer.next(false);
                    observer.complete();
                }
            });
        });
    }

}
